import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMediaStore } from './useMediaStore';
export function useFileHashes() {
  var fileHashes = useMediaStore(function (state) {
    return Object.fromEntries(Object.entries(state.files).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];
      return [key, val.hash];
    }));
  });
  return fileHashes;
}